
export const CREATE_REQUESTED = "PROJECTS/CREATE_REQUESTED";
export const CREATE_FAILED = "PROJECTS/CREATE_FAILED";
export const CREATE_SUCCEEDED = "PROJECTS/CREATE_SUCCEEDED";

export default (state = {
   loading: 0,
   data: {},
   errors: []
}, { type, data}) => {
   switch (type){
      case CREATE_REQUESTED: {
         ++state.loading;
         return state;
      }
      case CREATE_FAILED: {
         --state.loading;
         state.errors.push({error: data, type})
         return state;
      }
      case CREATE_SUCCEEDED: {
         --state.loading;
         state.data = data;
         return state;
      }
      default:
         return state;
   }
}

export const createRequested = (data, resolve, reject) => ({ type: CREATE_REQUESTED, data, resolve, reject});
export const createFailed = data => ({type: CREATE_FAILED, data});
export const createSucceeded = data => ({type: CREATE_SUCCEEDED, data});